const RECEIVE_ADCAMPAIGNS = 'src/adEntities/RECEIVE_ADCAMPAIGNS' as const;
const CLEAR_ADCAMPAIGNS = 'src/adEntities/CLEAR_ADCAMPAIGNS' as const;

export default {
  CLEAR_ADCAMPAIGNS,
  RECEIVE_ADCAMPAIGNS
};
